import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "submenuBtn"]

  connect() {
    this.controllerName = `users--works--meetings--dashboard--submenu`
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.doSubmenuPreloader()
  }

  goTo(ev) {
    var url = ev.target.dataset.url
    window.open(url, '_self');
  }

  goToDashboard() {
    this.getControllerByIdentifier("users--works--meetings--dashboard--index").teamDashboard()
  }

  goToOldPermissions() {
    var element = this.getControllerByIdentifier("users--works--meetings--dashboard--index").contentTarget

    this.getControllerByIdentifier("users--works--permissions--entities--user").subdomain = "work_meetings"
    this.getControllerByIdentifier("users--works--permissions--entities--user").account_kinds = ["team"]
    this.getControllerByIdentifier("users--works--permissions--entities--user").current_account_kind = "team"
    this.getControllerByIdentifier("users--works--permissions--entities--user").doPageGrid(element)
  }

  goToReports() {
    var element = this.getControllerByIdentifier("users--works--meetings--dashboard--index").contentTarget
    this.getControllerByIdentifier("users--works--meetings--reports--main").doMainGrid(element)
  }

  goToPermissions() {
    var element = this.getControllerByIdentifier("users--works--meetings--dashboard--index").contentTarget

    this.getControllerByIdentifier(`users--works--permissions--entities--list-users`).subdomain = "work_meetings"
    this.getControllerByIdentifier(`users--works--permissions--entities--list-users`).account_kinds = ["team"]
    this.getControllerByIdentifier(`users--works--permissions--entities--list-users`).current_account_kind = "team"
    this.getControllerByIdentifier(`users--works--permissions--entities--list-users`).doPageGrid(element)
    this.getControllerByIdentifier(`operations--dashboards--submenu`).dashboardToggleBtn(`PERMISSÕES`)
  }



  doSubmenuHtml() {

    var dashboardBtn = `<button type="button" data-action="${this.controllerName}#goToDashboard ${this.controllerName}#toggleBtn" class="btn btn-flat-dark btn-no-shadow btn-no-border btn-sm px-1 mx-1 f-065" data-${this.controllerName}-target="submenuBtn">Dashboard</button>`

    if (this.application.permissions.work_meeting_permissions.can_assign) {
      var permissionOldBtn = `<button type="button" data-action="${this.controllerName}#goToOldPermissions ${this.controllerName}#toggleBtn" class="btn btn-flat-dark btn-no-shadow btn-no-border btn-sm px-1 mx-1 f-065" data-${this.controllerName}-target="submenuBtn">Permissões Old</button>`
    } else {
      var permissionOldBtn = ``
    }

    if (this.application.permissions.work_meeting_permissions.can_assign) {
      var permissionBtn = `<button type="button" data-action="${this.controllerName}#goToPermissions ${this.controllerName}#toggleBtn" class="btn btn-flat-dark btn-no-shadow btn-no-border btn-sm px-1 mx-1 f-065" data-${this.controllerName}-target="submenuBtn">Permissões</button>`
    } else {
      var permissionBtn = ``
    }

    if (this.application.permissions.work_meeting_boards.can_report) {
      var reportsBtn = `<button type="button" data-action="${this.controllerName}#goToReports ${this.controllerName}#toggleBtn" class="btn btn-flat-dark btn-no-shadow btn-no-border btn-sm px-1 mx-1 f-065" data-${this.controllerName}-target="submenuBtn">Relatórios</button>`
    } else {
      var reportsBtn = ``
    }

    var html = `<div class="btn-group mx-auto" role="group" style="box-shadow:none" data-${this.controllerName}-target="datesBtnGroup">
                  ${dashboardBtn}
                  ${reportsBtn}
                  ${permissionBtn}
                  ${permissionOldBtn}
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.submenuBtnTargets[0].classList.remove(`btn-flat-dark`)
      controller.submenuBtnTargets[0].classList.add(`btn-primary`)
    })
  }

  toggleBtn(ev) {

    this.submenuBtnTargets.forEach(element => {
      element.classList.add(`btn-flat-dark`)
      element.classList.remove(`btn-primary`)
    })

    ev.currentTarget.classList.remove(`btn-flat-dark`)
    ev.currentTarget.classList.add(`btn-primary`)

  }

  dashboardToggleBtn(title) {

    var btn = ``

    this.submenuBtnTargets.forEach(element => {

      if (element.innerText == title) {
        btn = element
      }

      element.classList.add(`btn-flat-dark`)
      element.classList.remove(`btn-primary`)
    })

    btn.classList.remove(`btn-flat-dark`)
    btn.classList.add(`btn-primary`)

  }

  doSubmenuPreloader() {
    var html = `<div class="row mb-3 w-100">
                  <div class="col-1 px-1 offset-2">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                  <div class="col-1 px-1">${this.loader}</div>
                </div>`

    this.mainTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 



}
